import { CreateInstance } from "./config"
const ApprovalMacroAPI = CreateInstance("approval-macro")
export default ApprovalMacroAPI
